function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 34H25.5V30.6H17C9.622 30.6 3.4 24.378 3.4 17C3.4 9.622 9.622 3.4 17 3.4C24.378 3.4 30.6 9.622 30.6 17V19.431C30.6 20.774 29.393 22.1 28.05 22.1C26.707 22.1 25.5 20.774 25.5 19.431V17C25.5 12.308 21.692 8.5 17 8.5C12.308 8.5 8.5 12.308 8.5 17C8.5 21.692 12.308 25.5 17 25.5C19.346 25.5 21.488 24.548 23.018 23.001C24.123 24.514 26.027 25.5 28.05 25.5C31.399 25.5 34 22.78 34 19.431V17C34 7.616 26.384 0 17 0C7.616 0 0 7.616 0 17C0 26.384 7.616 34 17 34ZM17 22.1C14.178 22.1 11.9 19.822 11.9 17C11.9 14.178 14.178 11.9 17 11.9C19.822 11.9 22.1 14.178 22.1 17C22.1 19.822 19.822 22.1 17 22.1Z",
  fill: "#4A4A4A"
});

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.ed1763a9.svg";
export { ForwardRef as ReactComponent };